<template>
  <div class="field">
    <label class="mb-2 block"><strong>{{ titulo || 'SELECCIONE EXTRAS' }}</strong></label>
    <div v-if="cargando" class="flex align-items-center">
      <i class="pi pi-spin pi-spinner mr-2 text-primary"></i> Cargando extras...
    </div>
    <div v-else class="mt-2">
      <MultiSelect 
        v-model="seleccionados" 
        :options="extras" 
        optionLabel="nombre" 
        placeholder="Seleccione uno o más extras"
        display="chip"
        :maxSelectedLabels="20"
        filter
        class="w-full"
        @change="emitirCambio"
      >
        <template #option="slotProps">
          <div class="flex align-items-center">
            <span>{{ slotProps.option.nombre }}</span>
            <span v-if="slotProps.option.precio_venta > 0" class="text-green-600 font-bold ml-2">
              (Bs. {{ slotProps.option.precio_venta }})
            </span>
          </div>
        </template>
      </MultiSelect>

      <div v-if="extras.length === 0 && sinConexion" class="text-500 font-italic mt-2">
        Extras no disponibles sin conexión.
      </div>
      <div v-else-if="extras.length === 0" class="text-500 font-italic mt-2">
        No hay Extras disponibles o activos.
      </div>
    </div>
  </div>
</template>

<script>
import ProductService from '@/service/ProductService';
import { useConexion } from '@/stores';
import { leerCatalogo } from '@/services-offline/catalogoLocal';

// Caché a nivel de módulo, por sucursal (el precio de los extras depende de la sucursal)
const cachedExtras = {};
const fetchingExtrasPromise = {};

export default {
  name: 'CheckExtras',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    sucursalId: {
      type: [Number, String],
      default: null
    },
    titulo: {
      type: String,
      default: 'SELECCIONE EXTRAS'
    }
  },
  data() {
    return {
      extras: [],
      seleccionados: [],
      cargando: false,
      // Etapa 3A: sin servidor y sin catálogo local de la sucursal
      sinConexion: false,
      productService: null
    };
  },
  created() {
    this.productService = new ProductService();
    this.seleccionados = [...this.modelValue];
  },
  mounted() {
    this.cargarExtras();
  },
  watch: {
    modelValue: {
      handler(newVal) {
        this.seleccionados = [...newVal];
      },
      deep: true
    },
    sucursalId() {
      // Si cambia de sucursal se usa (o se descarga) la lista de esa sucursal
      this.cargarExtras();
    }
  },
  methods: {
    cargarExtras() {
      const sucursal = this.sucursalId;
      if (!sucursal) {
        this.extras = [];
        return;
      }

      if (cachedExtras[sucursal]) {
        this.extras = cachedExtras[sucursal];
        return;
      }

      if (!fetchingExtrasPromise[sucursal]) {
        // Sin red (o si el servidor falla) se usan los extras del catálogo local de la sucursal
        const desdeServidor = useConexion().modoOffline
          ? Promise.reject(new Error('sin conexión'))
          : this.productService.getExtras(sucursal).then(response => response.extras || []);
        fetchingExtrasPromise[sucursal] = desdeServidor.then(extras => {
          cachedExtras[sucursal] = extras;
          return { extras, sinConexion: false };
        }).catch(async err => {
          console.warn("Extras desde el catálogo local:", err);
          delete fetchingExtrasPromise[sucursal];
          const fila = await leerCatalogo(sucursal);
          return { extras: fila ? fila.extras || [] : [], sinConexion: !fila };
        });
      }

      this.cargando = true;
      fetchingExtrasPromise[sucursal].then(({ extras, sinConexion }) => {
        // Si la sucursal cambió mientras se descargaba, se ignora la respuesta vieja
        if (this.sucursalId == sucursal) {
          this.extras = extras;
          this.sinConexion = sinConexion;
        }
      }).finally(() => {
        this.cargando = false;
      });
    },
    emitirCambio() {
      this.$emit('update:modelValue', this.seleccionados);
      this.$emit('change', this.seleccionados);
    }
  }
}
</script>

<style scoped>
:deep(.p-multiselect-label) {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 4px;
  white-space: normal !important;
}
:deep(.p-multiselect-token) {
  margin-right: 0 !important;
  margin-bottom: 0 !important;
}
</style>

<style scoped>
</style>
